import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { PrivyStatus } from '@/types';

type Response = {
  page: {
    status: PrivyStatus;
  };
};

async function getPrivyStatus() {
  const { data } = await axios.get<Response>(
    'https://status.privy.io/summary.json',
  );
  return data.page.status;
}

type Options = {
  enabled?: boolean;
};

export default function usePrivyStatus({ enabled }: Options = {}) {
  return useQuery({
    queryKey: ['privy/status'],
    queryFn: () => getPrivyStatus(),
    enabled,
  });
}
